import { render, staticRenderFns } from "./DataLoggerConfigurationAutocomplete.vue?vue&type=template&id=f51a43aa&scoped=true&"
import script from "./DataLoggerConfigurationAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DataLoggerConfigurationAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51a43aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
